import { useState, useEffect } from "react";
import blogFetch from "../../axios/config";
import getToken from "../../services/token";
import getPermissions from "../../services/permissions";
import { setCookie, getCookie, removeCookie } from "../../section/cookie";

//Chama ao efeturar login e ao mudar de pagina.
export default function useAuth() {
  useEffect(() => {
    const token = getCookie("token");
    if (token) {
      blogFetch.defaults.headers.Authorization = `Bearer ${token}`;
      console.log(token)
      setCookie("login", true, 1);
    } else {
      removeCookie("login");
      removeCookie("token");
      blogFetch.defaults.headers.Authorization = undefined;
    }
  }, []);

  async function handleLogin() {
    const token = await getToken();
    setCookie("token", token, 7);    

    if (token === null) {
      removeCookie("login");
      removeCookie("token");
      //Limpa do axios para retornar erro na API
      blogFetch.defaults.headers.Authorization = undefined;
      return false;
    }
    const permissions = await getPermissions();
    setCookie("login", true, 1);
    setCookie("permissions", permissions, 7);
    blogFetch.defaults.headers.Authorization = `Bearer ${token}`;
    
    return true;
  }

  async function handleLogout() {
    removeCookie("login");
    removeCookie("token");
    removeCookie("userId");
    removeCookie("permissions");
    localStorage.clear();
    blogFetch.defaults.headers.Authorization = undefined;
    window.location.reload();
  }

  return { handleLogin, handleLogout };
}
